export const PlayBackRate = [0.5, 0.75, 1, 1.25, 1.5, 2];
